/**
 * Prefer the server-queued snapshot so fly overlays stay mounted across gameState churn.
 */
export function resolveVeilcasterWeaponStealFlyDisplayWeapon(grant) {
  if (!grant?.weaponInstanceId) {
    throw new Error('resolveVeilcasterWeaponStealFlyDisplayWeapon: grant.weaponInstanceId is required');
  }
  if (grant.weaponSnapshot) {
    return grant.weaponSnapshot;
  }
  return null;
}
